import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'categories-logged_out_product_batch-view';
/**
 * Logged out category page product batch view
 */
export function trackCategoriesLoggedOutProductBatchView(customParameterToken, customParameterToken2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken, customParameterToken2 },
    });
}
